import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../redux/store";
import { ISearchAPIPayload } from "../redux/types/common";
import TableList from "../Components/TableList";
import TableHeader from "../Components/TableHeader";
import FinesReportForm from "../Components/reports/FinesReportForm";
import {
  getReportData,
  onChangeReportsList,
} from "../redux/slices/reports.slice";
import {
  collectionColumns,
  fineReportColumns,
  statePerformanceColumns,
} from "../utils/constants";
import { useCallback } from "react";

const Reports = () => {
  const { loading, pageProps, data } = useSelector(
    (state: RootState) => state.reports
  );

  const dispatch = useDispatch<AppDispatch>();

  const getTableCols = useCallback(() => {
    return pageProps.reportType === "Fines Report"
      ? fineReportColumns
      : pageProps.reportType === "Collection Report"
      ? collectionColumns
      : statePerformanceColumns;
  }, [pageProps.reportType]);

  return (
    <div className="min-h-fit p-4 pt-3">
      <TableHeader
        title="Reports"
        onPageChange={(data: ISearchAPIPayload) => {
          dispatch(getReportData(data as any));
          dispatch(
            onChangeReportsList({
              ...data,
            })
          );
        }}
        loading={loading}
        pageProps={pageProps}
        onRefreshData={(data: ISearchAPIPayload) => {
          dispatch(
            onChangeReportsList({
              ...data,
            })
          );
        }}
        showSearch={false}
        showAdd={false}
        showRefresh={false}
        otherComponents={<FinesReportForm />}
      />
      {data?.totalRecords > 0 && (
        <TableList
          columns={getTableCols()}
          onPageChange={(data: ISearchAPIPayload) => {
            dispatch(getReportData(data as any));
            dispatch(
              onChangeReportsList({
                ...data,
              })
            );
          }}
          loading={loading}
          pageProps={pageProps}
          apiResponse={data}
        />
      )}
    </div>
  );
};

export default Reports;
